import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';

export class ApplicationPermissionsService {
  static $inject = [
    'ApplicationPermissionDomain',
  ];

  constructor(ApplicationPermissionDomain) {
    this.ApplicationPermissionDomain = ApplicationPermissionDomain;
  }

  /**
   *
   * @param orgId
   * @return {Promise<Object>}
   */
  getPermissions(orgId) {
    return this.ApplicationPermissionDomain.observe(orgId).take(1);
  }

  /**
   *
   * @param orgId
   * @return {Observable<Object>}
   */
  watchPermissions(orgId) {
    return this.ApplicationPermissionDomain.observe(orgId);
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/services/AppPermissionsService.js